module.exports = __webpack_public_path__ + "img/icon_coaching_herz_iso.33dc51bc.svg";